import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import withStyles from 'react-jss';
import { findKey, cloneDeep, filter } from 'lodash';
import Loading from '../../utility/Loading';
import Checkmark from '../../utility/Checkmark';
import { tenantsModalCopy as copy } from '../../../copy/advisor-dashboard/tenants-tab.json';
import ComponentHeader from '../../ecap/ComponentHeader';
import DashboardButton from './DashboardButtonEdit';
import {
  labelAndFileSelector,
  labelAndInput,
  effectiveDateSection,
  checkButtonErrors,
} from './modalUtil';
import {
  updateTenantPortraitImage,
  uploadTenantPhotoToS3,
  insertTenantFeatures,
  insertFeaturesByName,
  insertCareerCategories,
  insertCareers,
  insertDegrees,
  insertHighSchools,
  insertGameImages,
  insertHighSchoolClasses,
  insertSkillsCourseRecommendations,
  editTenantTableData,
} from '../../../store/actions';

import ErrorMessage from '../../ErrorMessage';

const fileCustom = {
  backgroundColor: (props) => ({
    '&::before': {
      backgroundColor: props.tenant?.primary || '#000000',
      content: `'Select'`,
      border: `1px solid $`,
    },
  }),
  button: (props) => ({
    backgroundColor: 'white',
    color: props.tenant?.primary || '#000000',
    border: `1px solid ${props.tenant?.primary || '#000000'}`,

    '&:hover': {
      backgroundColor: props.tenant?.primary || '#000000',
      border: `2px solid ${props.tenant?.primary || '#000000'}`,
      color: 'white',
    },
    '&:disabled': {
      color: 'black',
      border: 'none',
      backgroundColor: '#e5e5e5',
      padding: ' 0 34px',
      cursor: 'not-allowed',
    },
  }),
};
export class EditModal extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      id: '',
      name: '',
      logoLink: null,
      primary: '#000000',
      secondary: '#000000',
      logo: '',
      hero1: '',
      hero1Portrait: '',
      hero2: '',
      termsName: '',
      customGameImages: true,
      highSchoolFeatures: false,
      skillsCourseRecommendations: null,
      skillsCourseRecommendationsFeature: false,
      effectiveDateMonth: '',
      effectiveDateYear: '',
      careersData: null,
      careerCategoriesData: null,
      degreesData: null,
      schoolsCsv: null,
      gameImageCsv: null,
      csvErrorMessage: '',
      unauthorizedMessage: '',
      loading: true,
      loadingMessage: '',
      errors: {
        name: false,
        primary: false,
        secondary: false,
        logoLink: false,
        buttons: false,
        csv: false,
        unauthorized: false,
      },
      highSchoolClasses: null,
      showDashButtonSection: {
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
        6: false,
      },
      dashButtons: [
        { button1: [] },
        { button2: [] },
        { button3: [] },
        { button4: [] },
        { button5: [] },
        { button6: [] },
      ],
    };
  }

  errorMessages = {
    name: 'Required field. Must contain only alphanumeric characters.',
    logoLink: 'Must contain http:// or https:// prefix.',
    primary: 'Must be a valid 6-digit hex code.',
    secondary: 'Must be a valid 6-digit hex code.',
    buttons:
      'All buttons must have a label and redirect URL. All redirect URLs must contain http:// or https:// prefix.',
    termsName: 'Required field.',
    effectiveDateMonth: 'Required field',
    effectiveDateYear: 'Required field',
  };

  colorPrimary = {
    color: `${this.props.tenant?.primary || '#000000'}`,
  };

  buttonContainerStyle = {
    backgroundColor: `${this.props.tenant?.primary || '#000000'}`,
    border: `1px solid ${this.props.tenant?.primary || '#000000'}`,
  };

  disabledButtonContainerStyle = {
    backgroundColor: 'white',
    border: `1px solid #E0E0E0`,
    cursor: 'not-allowed',
  };

  addDashButton = {
    backgroundColor: `${this.props.tenant?.primary || '#000000'}`,
    padding: '0 2em',
  };

  updateValue = (stateVal, oldVal) => {
    this.setState({
      [stateVal]: !oldVal,
    });
  };

  basicInfoSection = () => {
    return (
      <div className="tenant-modal__basic-info">
        <div className="tenant-modal__row">
          {this.props.tenant.published ? (
            <div
              className={classNames(
                'tenant-modal__label-and-input',
                'tenant-modal__fill-space tenant-modal__margin-bottom'
              )}
            >
              <label className="tenant-modal__label" htmlFor="name">
                {copy.name}
              </label>
              <div className="tenant-modal__uneditable-name">
                {this.state.name}
              </div>
              <p className="tenant-modal__uneditable-subtext">
                {`${copy.urlRoot}${this.state.name.toLowerCase()}`}
              </p>
            </div>
          ) : (
            labelAndInput(
              'name',
              copy.name,
              'tenant-modal__fill-space tenant-modal__margin-bottom',
              this.state.name,
              this.handleInputChange,
              this.errorMessages.name,
              this.state.errors.name
            )
          )}
        </div>
        <div className="tenant-modal__row tenant-modal__margin-bottom">
          {labelAndInput(
            'logoLink',
            copy.logoLink,
            'tenant-modal__fill-space',
            this.state.logoLink,
            this.handleInputChange,
            this.errorMessages.logoLink,
            this.state.errors.logoLink
          )}
        </div>
        <div className="tenant-modal__column tenant-modal__margin-bottom">
          {labelAndFileSelector(
            copy.logo,
            copy.logoSubText,
            'logo',
            this.setFile,
            this.state.logo,
            this.props.classes.backgroundColor
          )}
        </div>
        <div className="tenant-modal__hr" />
      </div>
    );
  };

  colorAndHeroesSection = () => {
    return (
      <div className="tenant-modal__color-and-heroes">
        <div className="tenant-modal__column tenant-modal__margin-bottom">
          {labelAndFileSelector(
            copy.hero1Portrait,
            copy.hero1PortraitSubText,
            'hero1Portrait',
            this.setFile,
            this.state.hero1Portrait,
            this.props.classes.backgroundColor
          )}
        </div>
        <button
          tabIndex={0}
          type="button"
          onClick={() => this.handleUpdateTenantPortraitImage()}
          className="button--primary tenant-modal__add-dash-button tenant-modal__margin-bottom"
          style={this.addDashButton}
        >
          {copy.updatePortraitImage}
        </button>
        <div className="tenant-modal__hr" />
      </div>
    );
  };

  handleInputChange = (id, value) => {
    let stateVal = value;
    if ((id === 'secondary' || id === 'primary') && !value.startsWith('#')) {
      stateVal = `#${value}`;
    }
    this.setState({
      [id]: stateVal,
    });
  };

  labelAndInput = (id, label, className) => {
    return (
      <div className={classNames('tenant-modal__label-and-input', className)}>
        <label className="tenant-modal__label" htmlFor={id}>
          {label}
        </label>
        <input
          className="tenant-modal__input"
          id={id}
          value={this.state[id] || ''}
          onChange={(e) => {
            this.handleInputChange(id, e.target.value);
          }}
          maxLength={id === 'primary' || id === 'secondary' ? '7' : 'none'}
        />
        {(id === 'primary' || id === 'secondary') && (
          <div
            className="tenant-modal__color-block"
            style={{ backgroundColor: `${this.state[id]}` }}
          />
        )}
        {id === 'name' && (
          <p className="tenant-modal__subText">
            {`${copy.urlRoot}${this.state.name.toLowerCase()}`}
          </p>
        )}
        <ErrorMessage
          error={this.errorMessages[id]}
          hidden={!this.state.errors[id]}
        />
      </div>
    );
  };

  insertCategoriesCareersAndDegrees = async (tenantId) => {
    const {
      careerCategoriesData,
      careersData,
      degreesData,
      skillsCourseRecommendations,
      skillsCourseRecommendationsFeature,
    } = this.state;
    try {
      let response = await this.props.insertCareerCategories(
        tenantId,
        careerCategoriesData
      );
      if (response.status !== 200) return response.data;
      response = await this.props.insertCareers(tenantId, careersData);
      if (response.status !== 200) return response.data;
      response = await this.props.insertDegrees(tenantId, degreesData);
      if (response.status !== 200) return response.data;
      if (skillsCourseRecommendationsFeature && skillsCourseRecommendations) {
        response = await this.props.insertSkillsCourseRecommendations(
          tenantId,
          skillsCourseRecommendations
        );
        if (response.status !== 200) return response.data;
      }
    } catch (e) {
      return new Error(e);
    }
  };

  checkForErrors = async () => {
    const buttonErrors = await checkButtonErrors(this.state.dashButtons);
    const {
      errors,
      name,
      logoLink,
      primary,
      secondary,
      termsName,
      effectiveDateMonth,
      effectiveDateYear,
    } = this.state;
    const errorsClone = cloneDeep(errors);
    errorsClone.buttons = buttonErrors;
    const hexColor = /^#[0-9A-F]{6}$/i;
    errorsClone.primary = !primary.match(hexColor);
    errorsClone.buttons = buttonErrors;
    errorsClone.effectiveDateMonth = !effectiveDateMonth;
    errorsClone.effectiveDateYear = !effectiveDateYear;
    errorsClone.secondary = !secondary.match(hexColor);
    errorsClone.logoLink = !!(
      !!logoLink &&
      logoLink.length > 0 &&
      !logoLink.includes('http://') &&
      !logoLink.includes('https://')
    );
    errorsClone.name = !!(
      !name ||
      name.length === 0 ||
      name.match(/^[0-9A-Za-z]+$/) === null
    );
    errorsClone.termsName = !!(!termsName || termsName.length === 0);
    this.setState(() => ({
      errors: errorsClone,
    }));
    return Object.values(errorsClone).find((x) => !!x) !== undefined;
  };
  handleUpdateTenantPortraitImage = async () => {
    this.setState({ loading: true });
    this.updateLoadingMessage('Uploading image...');
    try {
      const hero1Portrait = await this.props.uploadTenantPhotoToS3(
        this.state.hero1Portrait,
        'hero-portrait-landing-page'
      );
      const body = {
        hero_portrait: hero1Portrait,
        tenantId: this.props.tenant.id,
      };
      await this.props.updateTenantPortraitImage(body);
      this.updateLoadingMessage('Uploading images...');
      this.setState({ loading: false, hero1Portrait: '' });
    } catch (e) {
      this.setState({ csvErrorMessage: e, loading: false });
      return e;
    }
  };
  updateLoadingMessage = (msg) => {
    this.setState({
      loadingMessage: msg,
    });
  };

  setFile = (e) => {
    this.setState({
      [e.target.id]: e.target.files[0],
    });
  };

  termsSection = () => {
    return (
      <div className="tenant-modal__terms-section">
        <div className="tenant-modal__row tenant-modal__margin-bottom">
          {labelAndInput(
            'termsName',
            copy.termsName,
            'tenant-modal__leave-room',
            this.state.termsName,
            this.handleInputChange,
            this.errorMessages.termsName,
            this.state.errors.termsName
          )}
        </div>
        {effectiveDateSection(
          this.state.effectiveDateMonth,
          this.handleMonthChange,
          this.errorMessages.effectiveDateMonth,
          this.state.errors.effectiveDateMonth,
          this.state.effectiveDateYear,
          this.handleYearChange,
          this.errorMessages.effectiveDateYear,
          this.state.errors.effectiveDateYear
        )}
        <div className="tenant-modal__hr" />
      </div>
    );
  };

  handleYearChange = (e) => {
    const filtered = e.target.value.replace(/[^0-9]/g, '');
    this.setState({
      effectiveDateYear: filtered,
    });
  };

  handleMonthChange = (e) => {
    this.setState({
      effectiveDateMonth: e,
    });
  };

  handleAddDashButton = () => {
    const { showDashButtonSection } = this.state;
    const result = findKey(showDashButtonSection, (x) => {
      return !x;
    });
    if (result !== undefined) {
      this.setState({
        showDashButtonSection: {
          ...showDashButtonSection,
          [result]: true,
        },
      });
      // console.log('added new button ...', {
      //   showDashButtonSection: {
      //     ...showDashButtonSection,
      //     [result]: true,
      //   },
      // });
    }
  };

  updateDashButton = (num, id, value, isDropdown, subButtons, buttonLabel) => {
    // console.log(
    //   '🚀 ~ EditModal ~ num, id, value, isDropdown, subButtons, buttonLabel values ::',
    //   num,
    //   id,
    //   value,
    //   isDropdown,
    //   subButtons,
    //   buttonLabel
    // );

    const clone = cloneDeep(this.state.dashButtons);

    if (!isDropdown) {
      if (clone[num - 1][`button${num}`][0]) {
        clone[num - 1][`button${num}`][0][id] = value;
      } else {
        clone[num - 1][`button${num}`] = [
          {
            [id]: value,
            isDropdown: false,
            buttonNumber: num,
            order: 1,
          },
        ];
      }
    }

    if (isDropdown) {
      clone[num - 1][`button${num}`] = [
        {
          labelEn: buttonLabel,
          isDropdown: true,
          buttonNumber: num,
          order: 1,
        },
        ...subButtons,
      ];
    }

    // console.log({ clone });
    this.setState(() => ({
      dashButtons: clone,
    }));
  };

  replaceDropdownWithButton = (num, buttonLabel, buttonValue) => {
    const clone = cloneDeep(this.state.dashButtons);

    clone[num - 1][`button${num}`] = [
      {
        labelEn: buttonLabel,
        value: buttonValue,
        isDropdown: false,
        buttonNumber: num,
        order: 1,
      },
    ];

    this.setState(() => ({
      dashButtons: clone,
    }));

    console.log({ newclone: clone });
  };

  removeDashboardButton = (buttonNum) => {
    console.log({ buttonNumToDelete: buttonNum });

    this.setState((prevState) => {
      const updatedDashButtons = prevState.dashButtons.filter(
        (_, index) => index !== buttonNum - 1
      );

      // Step 3: Reorder buttons correctly from 1 to 6
      const reorderedDashButtons = Array(6)
        .fill(null)
        .map((_, i) => {
          return updatedDashButtons[i]
            ? {
                [`button${i + 1}`]:
                  updatedDashButtons[i][Object.keys(updatedDashButtons[i])[0]],
              }
            : { [`button${i + 1}`]: [] };
        });

      // Step 2: Update showDashButtonSection with respect to reorderedDashButtons
      const updatedShowDashButtonSection = {};
      reorderedDashButtons.forEach((btn, index) => {
        updatedShowDashButtonSection[index + 1] =
          btn[`button${index + 1}`].length > 0;
      });

      console.log(
        '🚀 ~ EditModal ~ updatedShowDashButtonSection:',
        updatedShowDashButtonSection, reorderedDashButtons
      );

      return {
        dashButtons: reorderedDashButtons,
        showDashButtonSection: updatedShowDashButtonSection,
      };
    });
  };

  dashboardButtons = () => {
    const { showDashButtonSection, dashButtons } = this.state;

    return (
      <div className="tenant-modal__dashboard-buttons-section">
        {Object.keys(showDashButtonSection).map((num) => {
          if (showDashButtonSection[num])
            return (
              <DashboardButton
                colorPrimary={this.colorPrimary}
                checkboxAndLabel={this.checkboxAndLabel}
                num={num}
                key={num}
                button={dashButtons[num - 1][`button${num}`]}
                updateButtonOnParent={this.updateDashButton}
                replaceDropdown={this.replaceDropdownWithButton}
                removeButton={this.removeDashboardButton}
              />
            );
        })}
        {findKey(showDashButtonSection, (x) => {
          return !x;
        }) !== undefined && (
          <div className="tenant-modal__add-button-container">
            <button
              tabIndex={0}
              type="button"
              onClick={() => this.handleAddDashButton()}
              onKeyDown={(e) => {
                if (['Enter'].includes(e.key)) {
                  this.handleAddDashButton();
                }
              }}
              className="button--primary tenant-modal__add-dash-button tenant-modal__margin-bottom"
              style={this.addDashButton}
            >
              {copy.addDashButton}
            </button>
          </div>
        )}

        {/* {console.log(this.errorMessages.buttons)} */}
        <ErrorMessage
          error={this.errorMessages.buttons}
          hidden={!this.state.errors.buttons}
        />
        <div className="tenant-modal__hr" />
      </div>
    );
  };

  isButtonDisabled = () => {
    const {
      name,
      primary,
      secondary,
      logo,
      termsName,
      effectiveDateMonth,
      effectiveDateYear,
      hero1,
      hero2,
      careersData,
      careerCategoriesData,
      degreesData,
      schoolsCsv,
      gameImageCsv,
      highSchoolClasses,
      highSchoolFeatures,
      skillsCourseRecommendations,
      skillsCourseRecommendationsFeature,
    } = this.state;

    return (
      !name ||
      // (primary.length !== 4 && primary.length !== 7) ||
      // (secondary.length !== 4 && secondary.length !== 7) ||
      // !logo ||
      !termsName ||
      // !hero1 ||
      // !hero2 ||
      // !careersData ||
      // !careerCategoriesData ||
      // !degreesData ||
      // !schoolsCsv ||
      // !gameImageCsv ||
      // (skillsCourseRecommendationsFeature && !skillsCourseRecommendations) ||
      !effectiveDateMonth ||
      !effectiveDateYear
    );
  };

  componentDidMount = () => {
    const { tenant } = this.props;

    if (tenant) {
      const month = JSON.parse(tenant.termsInfo).effective_date_month;
      const monthObj = { value: month, label: month };
      this.setState({
        id: tenant.id,
        name: tenant.name,
        termsName: JSON.parse(tenant.termsInfo).name,
        logoLink: tenant.logoLink,
        primary: tenant.primary,
        secondary: tenant.secondary,
        loading: false,
        effectiveDateMonth: monthObj,
        effectiveDateYear: JSON.parse(tenant.termsInfo).effective_date_year,
        dashButtons: [
          {
            button1:
              Object.keys(tenant.button1).length > 0 ? [tenant.button1] : [],
          },
          {
            button2:
              Object.keys(tenant.button2).length > 0 ? [tenant.button2] : [],
          },
          {
            button3:
              Object.keys(tenant.button3).length > 0 ? [tenant.button3] : [],
          },
          {
            button4:
              Object.keys(tenant.button4).length > 0 ? [tenant.button4] : [],
          },
          {
            button5:
              Object.keys(tenant.button5).length > 0 ? [tenant.button5] : [],
          },
          {
            button6:
              Object.keys(tenant.button6).length > 0 ? [tenant.button6] : [],
          },
        ],
        showDashButtonSection: {
          1: Object.keys(tenant.button1).length > 0,
          2: Object.keys(tenant.button2).length > 0,
          3: Object.keys(tenant.button3).length > 0,
          4: Object.keys(tenant.button4).length > 0,
          5: Object.keys(tenant.button5).length > 0,
          6: Object.keys(tenant.button6).length > 0,
        },
      });

      // console.log({
      //   id: tenant.id,
      //   name: tenant.name,
      //   termsName: JSON.parse(tenant.termsInfo).name,
      //   logoLink: tenant.logoLink,
      //   primary: tenant.primary,
      //   secondary: tenant.secondary,
      //   loading: false,
      //   effectiveDateMonth: monthObj,
      //   effectiveDateYear: JSON.parse(tenant.termsInfo).effective_date_year,
      //   dashButtons: [
      //     { button1: [tenant.button1] },
      //     { button2: [tenant.button2] },
      //     { button3: [tenant.button3] },
      //     { button4: [tenant.button4] },
      //     { button5: [tenant.button5] },
      //     { button6: [tenant.button6] },
      //   ],
      //   showDashButtonSection: {
      //     1: Object.keys(tenant.button1).length > 0,
      //     2: Object.keys(tenant.button2).length > 0,
      //     3: Object.keys(tenant.button3).length > 0,
      //     4: Object.keys(tenant.button4).length > 0,
      //     5: Object.keys(tenant.button5).length > 0,
      //     6: Object.keys(tenant.button6).length > 0,
      //   },
      // });
    }
  };

  displayLoadingContent = () => {
    return (
      <div className="tenant-modal__loading-container">
        {this.state.loading ? (
          <Loading width="100%" />
        ) : (
          <div className="tenant-modal__success-container">
            <Checkmark color="green" />
          </div>
        )}
        <p className="tenant-modal__loading-message">
          {this.state.loadingMessage}
        </p>
      </div>
    );
  };

  saveOrEditCareersDegrees = () => {
    return (
      <>
        <div className="tenant-modal__center">
          <p className="tenant-modal__font-14px tenant-modal__margin-25">
            {copy.saveExplanation}
          </p>
          <button
            className={classNames(
              'button--primary',
              'tenant-modal__save-button',
              this.props.classes.button
            )}
            style={
              this.isButtonDisabled() ? this.disabledButtonContainerStyle : null
            }
            disabled={this.isButtonDisabled()}
            type="button"
            onClick={async () => {
              if (this.props.modalType === 'Create') {
                await this.createTenant();
              } else {
                await this.editTenant();
              }
            }}
          >
            {copy.saveButton}
          </button>
          <br />
          <p className="tenant-modal__font-14px">
            Would you like to update Careers or Degrees?
          </p>
          <p className="tenant-modal__font-14px">
            Make sure you save before leaving.
          </p>
          <div className="tenant-modal__update-buttons-container">
            <button
              className={classNames(
                'button--primary',
                'tenant-modal__update-button',
                this.props.classes.button
              )}
              type="button"
              onClick={async () =>
                this.props.openTenantModal('Careers', this.props.tenant.id)
              }
            >
              Update Careers
            </button>
            <button
              className={classNames(
                'button--primary',
                'tenant-modal__update-button',
                this.props.classes.button
              )}
              type="button"
              onClick={async () =>
                this.props.openTenantModal('Degrees', this.props.tenant.id)
              }
            >
              Update Degrees
            </button>
          </div>
        </div>
      </>
    );
  };

  validateButtons(data) {
    let error = false;

    data.forEach((button, index) => {
      const { isDropdown, labelEn, value, url } = button;

      // console.log('🚀 Validating button:', button);

      // 1️⃣ Common check: labelEn must not be empty
      if (!labelEn || labelEn.trim() === '') {
        // console.log(
        //   `Error at button ${index + 1}: labelEn is missing or empty.`
        // );
        error = true;
      }

      // 2️⃣ If isDropdown is false, value must start with "http://" or "https://"
      if (isDropdown === false) {
        const buttonValue = value || url; // Some buttons use "url" instead of "value"

        if (!buttonValue || buttonValue.trim() === '') {
          // console.log(
          //   `Error at button ${index + 1}: value is missing or empty.`
          // );
          error = true;
        } else if (
          !buttonValue.startsWith('http://') &&
          !buttonValue.startsWith('https://')
        ) {
          // console.log(
          //   `Error at button ${
          //     index + 1
          //   }: value must start with "http://" or "https://". Found: "${buttonValue}"`
          // );
          error = true;
        }
      }
    });

    return error;
  }

  editTenant = async () => {
    // console.log('edit called', this.state.dashButtons);

    this.setState((prevState) => ({
      errors: {
        ...prevState.errors,
        csv: false,
        unauthorized: '',
      },
      csvErrorMessage: '',
      loading: true,
      loadingMessage: 'Checking for errors...',
    }));

    const {
      errors,
      termsName,
      dashButtons,
      effectiveDateMonth,
      effectiveDateYear,
      id,
    } = this.state;


    const filtered = dashButtons.reduce((acc, button, index) => {
      const buttonKey = button[`button${index + 1}`] || [];

      if (!buttonKey.length) return acc; // Skip if button list is empty

      if (buttonKey.length > 1) {
        buttonKey.forEach((individualButton) => {
          acc.push({
            buttonNumber: index + 1,
            isDropdown: individualButton.isDropdown || false,
            order: individualButton.order,
            labelEn: individualButton.labelEn,
            value: individualButton?.value || '',
          });
        });
      } else {
        const firstButton = buttonKey[0];

        if (firstButton.isDropdown) {
          acc.push({
            buttonNumber: index + 1,
            isDropdown: true,
            order: 1,
            labelEn: firstButton.dropdownLabelEn,
            value: '',
          });

          firstButton.childButtons?.forEach((childButton) => {
            acc.push({
              buttonNumber: index + 1,
              isDropdown: false,
              ...childButton,
            });
          });
        } else {
          acc.push({
            buttonNumber: index + 1,
            isDropdown: false,
            order: firstButton.order || 1,
            labelEn: firstButton.labelEn,
            value: firstButton.value || '',
          });
        }
      }
      return acc;
    }, []);

    // ERROR CHECKING
    const errorsClone = cloneDeep(errors);
    const buttonErrors = this.validateButtons(filtered);
    errorsClone.buttons = buttonErrors;
    errorsClone.effectiveDateMonth = !effectiveDateMonth;
    errorsClone.effectiveDateYear = !effectiveDateYear;
    errorsClone.termsName = !!(!termsName || termsName.length === 0);

    this.setState(() => ({
      errors: errorsClone,
    }));

    const errorsPresent =
      Object.values(errorsClone).find((x) => !!x) !== undefined;

    if (errorsPresent) {
      this.setState({ loading: false });
      return;
    }

    try {
      const body = {
        id,
        buttons: filtered,
        terms_info: {
          name: termsName,
          effective_date_month: effectiveDateMonth.value,
          effective_date_year: effectiveDateYear,
        },
      };
      this.updateLoadingMessage('Updating tenant...');
      await this.props.editTenantTableData(body);
      this.updateLoadingMessage('Tenant updated successfully!');
      this.setState({ loading: false });
      this.props.closeTenantModal();
    } catch (e) {
      this.setState({
        csvErrorMessage: e,
        loading: false,
      });
      return e;
    }
  };

  render() {
    const { tenant } = this.state;
    const { csvErrorMessage, unauthorizedMessage } = this.state;
    let componentHeaderTenant = tenant;
    if (tenant === undefined) {
      componentHeaderTenant = {
        primary: this.state.primary,
        secondary: this.state.secondary,
      };
    }
    return (
      <>
        {this.state.loading ||
        this.state.loadingMessage === 'Tenant created successfully!' ? (
          this.displayLoadingContent()
        ) : (
          <>
            <ComponentHeader
              headerText={copy.editHeader}
              tenant={componentHeaderTenant}
              marginTop="0px"
            />
            {this.colorAndHeroesSection()}
            {this.termsSection()}
            {this.dashboardButtons()}
            {this.saveOrEditCareersDegrees()}
            {this.state.errors.csv && (
              <ErrorMessage
                error={csvErrorMessage}
                hidden={!this.state.errors.csv}
              />
            )}
            {this.state.errors.unauthorized && (
              <ErrorMessage
                error={unauthorizedMessage}
                hidden={!this.state.errors.unauthorized}
              />
            )}
          </>
        )}
      </>
    );
  }
}

export default connect(null, {
  uploadTenantPhotoToS3,
  editTenantTableData,
  updateTenantPortraitImage,
  insertTenantFeatures,
  insertFeaturesByName,
  insertCareerCategories,
  insertCareers,
  insertDegrees,
  insertHighSchools,
  insertGameImages,
  insertHighSchoolClasses,
  insertSkillsCourseRecommendations,
})(withStyles(fileCustom)(EditModal));
